"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
var _paulCorePackage = require("paul-core-package");
var _TemperatureStatus = _interopRequireDefault(require("./TemperatureStatus"));
var _TemperatureCircle = _interopRequireDefault(require("./TemperatureCircle"));
var _useGetValue = require("../../hooks/useGetValue");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const TemperatureCircleWrap = _ref => {
  let {
    thingPDIDDevice,
    hover = false
  } = _ref;
  const temperatureIds = (0, _useGetValue.useGetValueIdsByRegDeviceId)({
    thingPDIDDevice,
    regular: _paulCorePackage.constants.regularsByDisplayNameId.temperatureRegex
  });
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "flex-column justify-content-end h-100"
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "flex-center",
    sx: {
      gap: '0px 25px'
    }
  }, temperatureIds.length ? temperatureIds.map(id => /*#__PURE__*/_react.default.createElement(_TemperatureCircle.default, {
    key: id,
    thingPDIDDevice: thingPDIDDevice,
    displayNameId: id,
    hasPositionValue: temperatureIds.length > 1,
    hover: hover
  })) : /*#__PURE__*/_react.default.createElement(_TemperatureCircle.default, {
    thingPDIDDevice: thingPDIDDevice,
    displayNameId: null,
    hasPositionValue: false,
    hover: hover
  })), /*#__PURE__*/_react.default.createElement(_TemperatureStatus.default, {
    thingPDIDDevice: thingPDIDDevice,
    displayNameIds: temperatureIds
  }));
};
var _default = exports.default = TemperatureCircleWrap;